import { Button, Col, Modal, Row } from "antd";
import { DeleteFilled, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import React from "react";



const ConfirmDeleteModal = ({ isOpen, minWidthPercentage, title, subtitle, loading, onClose, onConfirm }) => {

    return (
        <Modal
            centered
            visible={isOpen}
            title={false}
            footer={false}
            closeIcon={false}
            destroyOnClose={true}
            style={{ minWidth: minWidthPercentage ?? "20%" }}
        >
            <Row gutter={24} style={{ marginTop: "-20px" }}>
                <Col span={24} className="p-0">
                    <Row gutter={24} className="p-4">
                        <Col span={24}>
                            <Row gutter={24} align="middle">
                                <Col span={24} className="text-center" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <div className="text-center icon-container" style={{ backgroundColor: "#fff1f0", border: "1px solid #ffccc7", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <DeleteFilled style={{ fontSize: "30px", fontWeight: "bold", color: "#ff6b72" }} />
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={24} className="mt-3">
                                <Col span={24} className="text-center">
                                    <h1 className="font-weight-bold">Fshirje!</h1>
                                </Col>
                            </Row>
                            <Row gutter={24} className="mt-3">
                                <Col span={24} className="text-center">
                                    <h3 style={{ fontSize: "20px" }} className="font-weight-semi-bold">{title}</h3>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={24} className="text-center">
                                    <h3 style={{ fontSize: "22px" }} className="text-muted">{subtitle}</h3>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row gutter={24} className="m-0">
                        <Col xl={2} lg={2} md={0} sm={0} xs={0} />
                        <Col xl={10} lg={10} md={12} sm={12} xs={12}>
                            <Button
                                block
                                loading={loading}
                                type="danger"
                                key="console"
                                style={{ height: '37px' }}
                                icon={<CheckOutlined />}
                                onClick={onConfirm}
                            >
                                Konfirmo
                            </Button>
                        </Col>
                        <Col xl={10} lg={10} md={12} sm={12} xs={12}>
                            <Button
                                block
                                ghost
                                disabled={loading}
                                type="primary"
                                key="console"
                                style={{ height: '37px' }}
                                icon={<CloseOutlined />}
                                onClick={onClose}
                            >
                                Mbyll
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Modal>
    )
};

export default ConfirmDeleteModal;